<template>
  <div>
    <access-information-content />
  </div>
</template>

<script>
import AccessInformationContent from "@/components/process/AccessInformationContent";

export default {
  data() {
    return {};
  },
  components: {
    AccessInformationContent,
  },
};
</script>
